module.exports = __webpack_public_path__ + "img/advantage1Orange.3eb8c340.png";